import React from 'react';
import { Button } from 'semantic-ui-react';
var defaultProps = {
  disabled: false,
  loading: false,
  checkoutDisabled: false
};
var AddToCartButton = function AddToCartButton(_ref) {
  var addToCartText = _ref.addToCartText,
    totalPrice = _ref.totalPrice,
    onAddToCart = _ref.onAddToCart,
    disabled = _ref.disabled,
    loading = _ref.loading,
    checkoutDisabled = _ref.checkoutDisabled;
  var addToCartTextStyle = checkoutDisabled ? {} : {
    "float": 'left'
  };
  return /*#__PURE__*/React.createElement(Button, {
    primary: true,
    onClick: onAddToCart,
    disabled: disabled || checkoutDisabled || loading,
    loading: loading
  }, /*#__PURE__*/React.createElement("div", {
    style: addToCartTextStyle
  }, addToCartText), /*#__PURE__*/React.createElement("div", {
    style: {
      "float": 'right'
    }
  }, !checkoutDisabled && "$".concat((+totalPrice).toFixed(2))));
};
AddToCartButton.defaultProps = defaultProps;
export default AddToCartButton;